export default __webpack_public_path__ + "static/media/testing.fd4952d9.jpg";